import { Section } from './section.model';

export class PermissionInfo {
  sections: Array<Section>;
}
